"use strict";
module.exports = {
    Console: function () { },
};
